




































import { Component, Vue } from 'vue-property-decorator'
import { ObserveVisibility } from 'vue-observe-visibility'
import NotificationsListState from '@/components/notifications-hub-content/notifications-list/notifications-list-state/notifications-list-state.vue'
import NotificationsListLoading from '@/components/notifications-hub-content/notifications-list/notifications-list-state/states/notifications-list-loading/notifications-list-loading.vue'
import { fetchNotifications } from '@/store/notifications/reducer'
import store, { currentState, initialState } from '@/store'
import { NotificationsState } from '@/store/notifications/interfaces'
import { initialNotificationsState } from '@/services/utils'

@Component({
  name: 'notifications-list-load-more',
  components: {
    NotificationsListState,
    NotificationsListLoading,
  },
  directives: {
    ObserveVisibility,
  },
  props: {
    state: {
      default: initialNotificationsState,
    },
  },
})
export default class NotificationsListLoadMoreComponent extends Vue {
  private unsubscribe: any | null = null

  visibilityChanged(isVisible: boolean): void {
    !(isVisible && !this.$props.state.allNotificationsLoaded) || this.loadMore()
  }

  loadMore(): void {
    fetchNotifications(this.$props.state.list.length)
  }
}
